import { render, staticRenderFns } from "./exam-level-edit.vue?vue&type=template&id=149538c8"
import script from "./exam-level-edit.vue?vue&type=script&lang=ts"
export * from "./exam-level-edit.vue?vue&type=script&lang=ts"
import style0 from "./exam-level-edit.vue?vue&type=style&index=0&id=149538c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports